const state = {
    paxList:null,
    valdList:null,
    selDob:null,
    selExpryDate:null

};

const getters = {
    GET_SEL_DOB: (state) => {
        return state.selDob;
    },
    GET_SEL_EXPRY_DATE: (state) => {
        return state.selExpryDate;
    },
    GET_PAX_LIST: (state) => {
        return state.paxList;
    },
    GET_VALD_LIST: (state) => {
        return state.valdList;
    }



};


const actions = {

    CLEAR_PAX_STORE: ({ commit }) => {
        commit('clearPaxStore');
    },
    SET_EXPRY_DATE: ({ commit }, selExpryDate) => {

        commit('saveSelExpryDate', selExpryDate);

    },
    SET_SEL_DOB: ({ commit }, selDob) => {

        commit('saveSelDob', selDob);

    },
    SET_VALD_LIST: ({ commit }, valdList) => {
        commit('saveValdList', valdList)
    },

  

    SET_PAX_LIST: ({ commit }, paxLs) => {
        commit('savePaxList', paxLs)
    }




};


const mutations = {
    clearPaxStore: (state) => {
       
       state.valdList=null;
        state.paxList=null;
        state.selDob=null;
        state.selExpryDate = null;
    },
    saveSelExpryDate: (state, selExpryDate) => {
        state.selExpryDate = selExpryDate;
    },
    saveSelDob: (state, selDob) => {
        state.selDob = selDob;
    },
    saveValdList: (state, valdList) => {
        state.valdList = valdList;
    },
    
    savePaxList: (state, paxLs) => {
        state.paxList = paxLs;
    }


};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}